import { useEffect, useMemo } from 'react';
import { useToggle } from 'react-use-v13';
import { useTranslateTask } from 'react-scale/corp/views/CorpProjectGroupManager/communication/apiClient';

interface UseTranslationManagementProps {
  responses: any;
  params: any;
  readOnly: boolean;
  taskAttemptId?: string;
  auditAttemptId?: string;
}

export const useTranslationManagement = ({
  responses,
  params,
  readOnly,
  taskAttemptId,
  auditAttemptId,
}: UseTranslationManagementProps) => {
  const [showTranslatedResponses, handleTranslationToggle] = useToggle(false);

  // Include attempt IDs in the task object so query key naturally includes them
  const taskWithAttemptContext = {
    response: responses,
    params,
    taskAttemptId,
    auditAttemptId,
  };

  const {
    data: translatedTask,
    isLoading: isLoadingTranslatingResponses,
    refetch: fetchTranslatedResponses,
  } = useTranslateTask(taskWithAttemptContext);

  const translatedResponses = useMemo(() => translatedTask?.task?.response, [translatedTask]);
  const translatedParams = useMemo(() => translatedTask?.task?.params, [translatedTask]);

  // Handle translation fetching
  useEffect(() => {
    if (!readOnly) {
      handleTranslationToggle(false);
      return;
    }

    if (showTranslatedResponses) {
      fetchTranslatedResponses();
    }
  }, [
    showTranslatedResponses,
    responses,
    params,
    fetchTranslatedResponses,
    readOnly,
    handleTranslationToggle,
  ]);

  return {
    showTranslatedResponses,
    translatedTask,
    translatedResponses,
    translatedParams,
    isLoadingTranslatingResponses,
    handleTranslationToggle,
    fetchTranslatedResponses,
  };
};
